import { useNavigate } from "react-router-dom";

// Third-party libraries
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  Button,
  Stack,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

// Project-specific imports
import dataConstant from "../../constants/dataConstants";

const RewardDialog = (props) => {
  const navigate = useNavigate();

  const {
    type,
    open,
    onClose,
    onPurchase,
    onReceiveDiscount,
    refURL,
    isConsultantPackagePurchased,
    t,
  } = props;

  if (type === dataConstant.DialogTypes.Purchase) {
    return (
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <Stack
          sx={(theme) => ({
            background: theme.palette.common.black,
            borderTopLeftRadius: "20px",
            borderTopRightRadius: "20px",
          })}
        >
          <DialogTitle
            sx={{
              fontWeight: 600,
              color: "secondary.light",
              borderBottom: "1px solid var(--headerbg)",
              px: 3,
              py: 2,
            }}
          >
            {t("RewardPage.PurchasePackage")}
            <IconButton
              aria-label="close"
              onClick={onClose}
              className="close-icon-bg"
              sx={(theme) => ({
                position: "absolute",
                right: 8,
                top: 8,
                color: theme.palette.grey[500],
              })}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
        </Stack>
        <DialogContent
          sx={{
            background: "var(--background-card)!important",
            border: 0,
          }}
          dividers
        >
          <Typography variant="body1" color="secondary.text">
            {t("RewardPage.PurchasePackageText")}
          </Typography>
          <Stack direction={{ xs: "column", sm: "row" }} mt={"10px"} gap={2}>
            <Button onClick={onPurchase} variant="contained" color="primary">
              {t("RewardPage.PurchasePackage")}
            </Button>
          </Stack>
        </DialogContent>
      </Dialog>
    );
  }

  if (type === dataConstant.DialogTypes.Success) {
    return (
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <Stack
          sx={(theme) => ({
            background: theme.palette.common.black,
            borderTopLeftRadius: "20px",
            borderTopRightRadius: "20px",
          })}
        >
          <DialogTitle
            sx={{
              fontWeight: 600,
              color: "secondary.light",
              borderBottom: "1px solid var(--headerbg)",
              px: 3,
              py: 2,
            }}
          >
            {t("RewardPage.Congratulation")}
            <IconButton
              aria-label="close"
              onClick={onClose}
              className="close-icon-bg"
              sx={(theme) => ({
                position: "absolute",
                right: 8,
                top: 8,
                color: theme.palette.grey[500],
              })}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
        </Stack>
        <DialogContent
          sx={{
            background: "var(--background-card)!important",
            border: 0,
            borderBottomLeftRadius: "20px",
            borderBottomRightRadius: "20px",
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
          dividers
        >
          <Typography variant="body1" color="secondary.text">
            {t("RewardPage.SignUpSuccessText")}
          </Typography>
          <Stack direction={"row"} spacing={3} flexWrap="wrap">
            <Button
              onClick={onReceiveDiscount}
              variant="contained"
              color="primary"
              sx={{ px: 3, width: { xs: "100%", sm: "auto" } }}
            >
              {t("RewardPage.ReceiveDiscount")}
            </Button>
          </Stack>
        </DialogContent>
      </Dialog>
    );
  }

  if (type === dataConstant.DialogTypes.Upgrade) {
    return (
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle
          sx={{
            fontWeight: 600,
            color: "secondary.light",
            borderBottom: "1px solid var(--headerbg)",
            px: 3,
            py: 2,
          }}
        >
          {t("Common.SignUp")}
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={(theme) => ({
              position: "absolute",
              right: 8,
              top: 8,
              color: theme.palette.grey[500],
            })}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ px: 3, py: 2 }}>
          <Stack spacing={2} sx={{ mt: 1 }}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={() =>
                navigate(`/IBOSignup/BYLDer/${refURL}`, {
                  state: { upgrade: true },
                })
              }
            >
              {dataConstant.Packages.BYLDer}
            </Button>
            {!isConsultantPackagePurchased && (
              <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={() =>
                  navigate(`/IBOSignup/Consultant/${refURL}`, {
                    state: { upgrade: true },
                  })
                }
              >
                {dataConstant.Packages.Consultant}
              </Button>
            )}
          </Stack>
        </DialogContent>
      </Dialog>
    );
  }

  return null;
};

export default RewardDialog;
